<template>
  <div>
    <b-card  title="Gestão de Vetorização">
      <b-tabs>
        <b-tab title="Regra de exclusão" active>
          <b-card>
            <b-button
              class="btn-sm btn-nav-link btn-nav-link-white"
              size="sm"
              variant="flat-primary"
              :to="{ name: 'admin-vectorization-management-register' }"
            >
              <feather-icon icon="PlusIcon" />
              Adicionar
            </b-button>
            <b-button
              class="btn-sm btn-nav-link btn-nav-link-white"
              size="sm"
              variant="flat-primary"
              @click="reportData"
            >
              <feather-icon icon="FileTextIcon" />
              Exportar
            </b-button>
            <custom-g-table
              v-if="displayTable"
              :displayLoading="tableLoading"
              :fields="fields"
              :items="data"
              :hasEditButton="true"
              :hasDeleteButton="true"
              :totalRows="totalRows"
              :limit="limit"
              @changePage="onChangePage"
              @onEdit="onEdit"
              @onDelete="onDelete"
              @onSortChange="onSortChange"
              @onColumnFilter="onFilter"
            />
          </b-card>
        </b-tab>
        <b-tab title="Sincronização de dados">
          <vectorization-management-sincronize-data />
        </b-tab>
      </b-tabs>

      
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard, BTab, BTabs } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import vectorizationManagementService from "@/providers/vectorizationManagementService";
import dropdownService from "@/providers/dropdownService";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import AppConstants from "@/appConstants";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import VectorizationManagementSincronizeData from './VectorizationManagementSincronizeData.vue';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object,
  },
  components: {
    BButton,
    BCard,
    CustomGTable,
    BTab,
    BTabs,
    VectorizationManagementSincronizeData,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "origin", label: "Origem", type: "object", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "subjects", label: "Assuntos", type: "array", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por assuntos', filterDropdownItems: [] } },
        { field: "tags", label: "Tags", type: "array", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por tags', filterDropdownItems: [] } },
        { field: "external_source_origin", label: "Fonte externa", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por fonte' } },
        { field: "layout", label: "Layout", sortable: false },
        { field: "dt_period", label: "Período", type: "custom_date", sortable: true },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "active", label: "Ativo", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por ativo', filterDropdownItems: [{ value: true, text: 'Sim' }, { value: false, text: 'Não' }] } },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Gestão de Vetorização");
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach((item) => {
        const idx = this.fields.findIndex((val) => val.field == item);
        if (idx >= 0 && this.fields[idx].filterOptions) {
          this.fields[idx].filterOptions.filterValue = this.urlQuery[item];
        }
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      vectorizationManagementService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "vectorization-management.xlsx");
          link.setAttribute("id", "link-download");
          document.body.appendChild(link);
          link.click();
          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          const origins = res.map((item) => {
            return { value: item.id, text: item.name };
          });
          const originFieldIdx = this.fields.findIndex((item) => item.field == "origin");
          if (originFieldIdx >= 0) {
            this.fields[originFieldIdx].filterOptions.filterDropdownItems = origins;
          }
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_VECTORIZATION_MANAGEMENT_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      const params = new URLSearchParams();
      vectorizationManagementService
        .delete(data._id, params)
        .then(() => {
          messageDialogHelper.displayDeleteSuccessMessage(() => {
            this.loadData();
          });
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', vectorizationManagementService.getAll(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style></style>
